import React, { Component } from 'react';
import AddUnit from '../components/crud/AddUnit';
import AddSkill from '../components/crud/AddSkill';
import { getSeries, getSkills, getWordtags, addParts, addSkill } from '../actions';
import { connect } from 'react-redux';



const mapStateToProps = (state) => {

	return {
		seriesListing: state.crud.series,
		skillsListing: state.crud.skills,
		addedSkill: state.crud.skill,
		addPartStatus: state.crud.addPartStatusText,
		addSkillStatus: state.crud.addSkillStatusText,
		refreshSkillsStatus: state.crud.refreshSkillStatusText,
		wordtagsListing: state.crud.wordtags,
	};
};

const mapDispatchToProps = (dispatch) => {

	return {
		getSeriesListing: () => {

			getSeries(dispatch);
		},
		getSkillsListing: () => {

			getSkills(dispatch);
		},
		getWordtagsListing: () => {

			getWordtags(dispatch);
		},		
		addNewParts: (parts) => {

			addParts(dispatch, parts);
		},
		addNewSkill: (skill) => {

			addSkill(dispatch, skill);
		},		
	}
};

class Crud extends Component {

	componentDidMount() {

		const { getSeriesListing, getSkillsListing, getWordtagsListing } = this.props;

		getSeriesListing();
		getSkillsListing();
		getWordtagsListing();
	}

	render() {

		const {
			seriesListing,
			skillsListing,
			wordtagsListing,
			addNewParts,
			addNewSkill,
			getSkillsListing,
			addedSkill,
			addPartStatus,
			addSkillStatus,
			refreshSkillsStatus,
		} = this.props;

		return (
			<div className='pa2'>
				<h1 className='ml2'>GBGW Management</h1>
				<AddSkill addNewSkill={addNewSkill} recentlyAddedSkill={addedSkill} addSkillStatus={addSkillStatus} />
				<AddUnit
					series={seriesListing}
					skills={skillsListing}
					wordtags={wordtagsListing}
					addParts={addNewParts}
					addPartStatus={addPartStatus}
					getSkills={getSkillsListing}
					refreshSkillsStatus={refreshSkillsStatus}
				/>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Crud);